<template>
  <v-card :min-width="widgetWidth" class="ma-0 pa-0" :loading="loading">
    <v-card-title
      v-if="!loading"
      class="pa-0 ma-0"
      style="max-height: 40px !important"
    >
      <widget-header
        :title="getTitle"
        :color="settingsModel.color ? settingsModel.color : '#607d8b'"
      >
        <template slot="actions">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="refresh"
                >mdi-refresh</v-icon
              >
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="mr-2" @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </template>
      </widget-header>
    </v-card-title>
    <v-card-text
      class="pa-0 ma-0"
      :style="`height: ${widgetHeight - headerHeight}px;max-height: ${
        widgetHeight - headerHeight
      }px`"
    >
      <base-no-data v-if="!loading && !hasData && widgetHeight > 39" />
      <v-list
        shaped
        v-if="!loading && hasData"
        class="ma-0 pa-0 overflow-y-auto"
        :style="`height: ${widgetHeight - headerHeight}px;max-height: ${
          widgetHeight - headerHeight
        }px`"
      >
        <template v-for="(item, index) in data">
          <div
            :key="`dashboard-list-item-${item.Id}${widgetId}`"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop($event, item)"
          >
            <v-divider v-if="index > 0"></v-divider>
            <v-list-item
              :to="getRoute(item.Id)"
              style="min-height: 35px"
              
            >
              <v-list-item-content class="ma-0 pa-1" :class="{ 'disabled-item': item.IsDisabled }">
                <v-list-item-title>{{ item.Description }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon class="ma-0 pa-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-if="item.IsDisabled"
                      color="warning"
                      class="mr-2"
                      >mdi-alert</v-icon
                    >
                  </template>
                  <span>{{ $t("DisabledFolderWarn") }}</span>
                </v-tooltip>
                <v-chip v-show="!item.loading">{{ item.Count }}</v-chip>
                <v-chip v-show="item.loading">
                  <v-progress-circular
                    v-show="item.loading"
                    indeterminate
                    color="black"
                    width="1"
                    size="6"
                  ></v-progress-circular
                ></v-chip>
              </v-list-item-icon>
            </v-list-item>
          </div>
        </template>
      </v-list>
      <WidgetSettingsModal :ref="modalKey" @on-save="onSettingsSave" />
      <DocumentModal :ref="documentModalKey" @on-document-created="refresh" />
      <ContentTypeSelector
        ref="contentTypeSelectorModal"
        @on-select="onContentTypeSelected"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetSettingsModal from "@/components/widgets/basket/WidgetBasketSettings";
import WidgetSettings from "@/ecm/models/widget/basket/BasketSettings";
import ContentTypeSelector from "@/components/widgets/basket/WidgetBasketContentTypeSelector";
import WidgetService from "@/services/WidgetService";
import WidgetHeader from "@/components/widgets/WidgetHeader";
import SearchType from "@/ecm/variables/SearchType";
import DocumentModal from "@/components/document/documentModal/DocumentModal";
import BasketService from "@/services/BasketService";
import { mapGetters } from "vuex";

export default {
  components: {
    WidgetHeader,
    WidgetSettingsModal,
    DocumentModal,
    ContentTypeSelector,
  },
  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    settings: { type: Object },
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.settingsModel = new WidgetSettings(this.settings);
    this.refresh();

    this.connection = $.hubConnection(this.apiUrl);
    this.connection.qs = { access_token: this.token };
    var notificationHub = this.connection.createHubProxy("notificationHub");
    let self = this;
    notificationHub.on("refresh", (notifications) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(self.refresh, 5000);
    });
    this.connection.start();
  },
  destroyed() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  },
  data() {
    return {
      connection: null,
      title: "",
      color: "",
      loading: false,
      hasData: false,
      data: [],
      headerHeight: 40,
      widgetHeight: 0,
      widgetWidth: 20,
      settingsModel: new WidgetSettings(),
      modalKey: "modalSettingsKey",
      documentModalKey: "documentModal",
      selectedContentType: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "account/user",
      apiUrl: "account/apiUrl",
      token: "account/token",
      userContentTypes: "account/userContentTypes",
    }),
    modalSettings() {
      return this.$refs[this.modalKey];
    },
    getTitle() {
      if (this.settingsModel.widgetTitle) {
        return this.settingsModel.widgetTitle;
      } else {
        return this.$t("Baskets");
      }
    },
    documentModalInstance() {
      return this.$refs[this.documentModalKey];
    },
  },
  methods: {
    setColor() {
      if (this.settingsModel.color == null || "") {
        return "#607d8b";
      } else {
        return this.settingsModel.color;
      }
    },
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
    },
    showSettings() {
      this.modalSettings.show(this.id, this.settingsModel.toDto());
    },
    onSettingsSave(dto) {
      this.settingsModel = new WidgetSettings(dto);
      this.refresh();
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
    refresh() {
      this.loading = true;
      WidgetService.getData({
        WidgetID: this.widgetId,
        Settings: this.settingsModel.toDto(),
      }).then((data) => {
        this.loading = false;

        if (data.length == 0) {
          this.hasData = false;
          return;
        }

        this.data = data;
        this.hasData = true;
        this.getDasbhoardItemsDocumentCount();
      });
    },
    getDasbhoardItemsDocumentCount() {
      this.data
        .filter((item) => !item.Count)
        .forEach((item) => {
          if (!item.IsDisabled) {
            item.loading = true;
            BasketService.getDocumentCount(item).then((count) => {
              item.Count = count;
              item.loading = false;
            });
          } else {
            item.Count = "D";
          }
        });
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
    getRoute(id) {
      const item = this.data.find((element) => element.Id === id);
      if (item && !item.IsDisabled) {
        return `search/${SearchType.Basket}/${id}`;
      } else {
        return null;
      }
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("yellow")) {
        event.currentTarget.classList.remove("grey");
        event.currentTarget.classList.remove("lighten-5");
        event.currentTarget.classList.add("yellow");
        event.currentTarget.classList.add("lighten-3");
      }
    },
    dragleave(event) {
      event.currentTarget.classList.add("grey");
      event.currentTarget.classList.add("lighten-5");
      event.currentTarget.classList.remove("yellow");
      event.currentTarget.classList.remove("lighten-3");
    },
    drop(event, item) {
      event.preventDefault();
      var files = event.dataTransfer.files;
      if (files.length > 0) {
        var contentTypes = item.ContentTypeIDs.split(",");
        if (contentTypes.length == 1) {
          this.documentModalInstance.createFromBasket(
            contentTypes[0],
            item.FilterStr,
            files
          );
        } else {
          this.selectedContentType = {
            filter: item.FilterStr,
            files: files,
          };
          this.$refs["contentTypeSelectorModal"].show(contentTypes);
        }
      }
      event.currentTarget.classList.add("grey");
      event.currentTarget.classList.add("lighten-5");
      event.currentTarget.classList.remove("yellow");
      event.currentTarget.classList.remove("lighten-3");
    },
    onContentTypeSelected(contentTypeId) {
      this.documentModalInstance.createFromBasket(
        contentTypeId,
        this.selectedContentType.filter,
        this.selectedContentType.files
      );
    },
  },
};
</script>

<style>
.disabled-item {
  opacity: 0.5; 
}
</style>
